import styled from "styled-components";
import { darken, transparentize } from "polished";
const secondaryColor = "#0000a0";

export const Container = styled.button`
  background-color: var(--secondaryColor);
  padding: 10px 30px;
  border-radius: 20px;
  overflow: hidden;
  border: none;
  cursor: pointer;
  color: var(--primaryColor);
  font-weight: bold;
  transition: all 0.2s;
  &:hover {
    background-color: ${darken(0.1, secondaryColor)};
  }
`;
